<template>
  <base-dialog
    @save-item="saveItem"
    dialogId="create-nas-dialog"
    :open.sync="openDialog"
    :form-ref.sync="nasFormRef"
    :loading.sync="isLoading"
  >
    <template v-slot:[`dialog.title`]>
      <span>Modifier un NAS</span>
    </template>
    <template v-slot:[`dialog.content`]>
      <v-container>
        <nas-form
          :nas-form.sync="nasForm"
          :rules="rules"
          :nas-identifier="false"
        ></nas-form>
      </v-container>
    </template>
    <template v-slot:[`dialog.actions.save`]>Modifier</template>
  </base-dialog>
</template>
<script>
import { toRefs, onMounted, computed } from "@vue/composition-api";
import NasForm from "@/components/Nas/NasForm";
import { useNas } from "@/composables/nas";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    NasForm,
    BaseDialog,
  },
  props: {
    nas: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { nasData, updateNas } = useNas();

    /* Variables */
    const {
      password,
      description,
      monitoringType,
      monitoringIp,
      nasType,
      active,
    } = props.nas;

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      await updateNas(props.nas);
      openDialog.value = nasData.editNasDialog;
    };

    /* Cycle de vie */
    onMounted(() => {
      nasData.nasForm = {
        password,
        description,
        monitoringType: monitoringType.id,
        monitoringIp,
        nasType: nasType.id,
        active,
      };
    });

    return {
      updateNas,
      ...toRefs(nasData),
      openDialog,
      saveItem,
    };
  },
};
</script>
